import EventEmitter from 'eventemitter3';

/**
 * Data from Chainlist
 * @see https://chainlist.org
 */
const chain = {
  mainnet: {
    id: 1,
    name: 'Mainnet',
    nativeCurrency: {
      name: 'Ether',
      symbol: 'ETH',
      decimals: 18
    },
    rpcUrls: ['https://mainnet.infura.io/v3'],
    blockExplorers: [{
      name: 'Etherscan',
      url: 'https://etherscan.io'
    }]
  },
  ropsten: {
    id: 3,
    name: 'Ropsten',
    nativeCurrency: {
      name: 'Ropsten Ether',
      symbol: 'ropETH',
      decimals: 18
    },
    rpcUrls: ['https://ropsten.infura.io/v3'],
    blockExplorers: [{
      name: 'Etherscan',
      url: 'https://ropsten.etherscan.io'
    }],
    testnet: true
  },
  rinkeby: {
    id: 4,
    name: 'Rinkeby',
    nativeCurrency: {
      name: 'Rinkeby Ether',
      symbol: 'rETH',
      decimals: 18
    },
    rpcUrls: ['https://rinkeby.infura.io/v3'],
    blockExplorers: [{
      name: 'Etherscan',
      url: 'https://rinkeby.etherscan.io'
    }],
    testnet: true
  },
  goerli: {
    id: 5,
    name: 'Goerli',
    nativeCurrency: {
      name: 'Goerli Ether',
      symbol: 'gETH',
      decimals: 18
    },
    rpcUrls: ['https://goerli.infura.io/v3'],
    blockExplorers: [{
      name: 'Etherscan',
      url: 'https://goerli.etherscan.io'
    }],
    testnet: true
  },
  kovan: {
    id: 42,
    name: 'Kovan',
    nativeCurrency: {
      name: 'Kovan Ether',
      symbol: 'kETH',
      decimals: 18
    },
    rpcUrls: ['https://kovan.infura.io/v3'],
    blockExplorers: [{
      name: 'Etherscan',
      url: 'https://kovan.etherscan.io'
    }],
    testnet: true
  },
  optimism: {
    id: 10,
    name: 'Optimism',
    nativeCurrency: {
      name: 'Ether',
      symbol: 'ETH',
      decimals: 18
    },
    rpcUrls: ['https://mainnet.optimism.io'],
    blockExplorers: [{
      name: 'Etherscan',
      url: 'https://optimistic.etherscan.io'
    }]
  },
  optimismKovan: {
    id: 69,
    name: 'Optimism Kovan',
    nativeCurrency: {
      name: 'Kovan Ether',
      symbol: 'KOR',
      decimals: 18
    },
    rpcUrls: ['https://kovan.optimism.io'],
    blockExplorers: [{
      name: 'Etherscan',
      url: 'https://kovan-optimistic.etherscan.io'
    }],
    testnet: true
  },
  polygonMainnet: {
    id: 137,
    name: 'Polygon Mainnet',
    nativeCurrency: {
      name: 'MATIC',
      symbol: 'MATIC',
      decimals: 18
    },
    rpcUrls: ['https://polygon-rpc.com', 'https://rpc-mainnet.matic.network', 'https://matic-mainnet.chainstacklabs.com', 'https://rpc-mainnet.maticvigil.com', 'https://rpc-mainnet.matic.quiknode.pro', 'https://matic-mainnet-full-rpc.bwarelabs.com'],
    blockExplorers: [{
      name: 'Polygonscan',
      url: 'https://polygonscan.com'
    }]
  },
  polygonTestnetMumbai: {
    id: 80_001,
    name: 'Mumbai',
    nativeCurrency: {
      name: 'MATIC',
      symbol: 'MATIC',
      decimals: 18
    },
    rpcUrls: ['https://matic-mumbai.chainstacklabs.com', 'https://rpc-mumbai.maticvigil.com', 'https://matic-testnet-archive-rpc.bwarelabs.com'],
    blockExplorers: [{
      name: 'Polygonscan',
      url: 'https://mumbai.polygonscan.com'
    }],
    testnet: true
  },
  arbitrumOne: {
    id: 42_161,
    name: 'Arbitrum One',
    nativeCurrency: {
      name: 'Ether',
      symbol: 'AETH',
      decimals: 18
    },
    rpcUrls: ['https://arb1.arbitrum.io/rpc'],
    blockExplorers: [{
      name: 'Arbiscan',
      url: 'https://arbiscan.io'
    }, {
      name: 'Arbitrum Explorer',
      url: 'https://explorer.arbitrum.io'
    }]
  },
  arbitrumRinkeby: {
    id: 421_611,
    name: 'Arbitrum Rinkeby',
    nativeCurrency: {
      name: 'Arbitrum Rinkeby Ether',
      symbol: 'ARETH',
      decimals: 18
    },
    rpcUrls: ['https://rinkeby.arbitrum.io/rpc'],
    blockExplorers: [{
      name: 'Arbitrum Explorer',
      url: 'https://rinkeby-explorer.arbitrum.io'
    }],
    testnet: true
  },
  avalanche: {
    id: 43_114,
    name: 'Avalanche Mainnet',
    nativeCurrency: {
      name: 'Avalanche',
      symbol: 'AVAX',
      decimals: 18
    },
    rpcUrls: ['https://api.avax.network/ext/bc/C/rpc'],
    blockExplorers: [{
      name: 'SnowTrace',
      url: 'https://snowtrace.io'
    }],
    testnet: false
  },
  avalancheFuji: {
    id: 43_113,
    name: 'Avalanche Fuji Testnet',
    nativeCurrency: {
      name: 'Avalanche',
      symbol: 'AVAX',
      decimals: 18
    },
    rpcUrls: ['https://api.avax-test.network/ext/bc/C/rpc'],
    blockExplorers: [{
      name: 'SnowTrace',
      url: 'https://testnet.snowtrace.io'
    }],
    testnet: true
  },
  localhost: {
    id: 1_337,
    name: 'Localhost',
    rpcUrls: ['https://127.0.0.1:8545']
  },
  hardhat: {
    id: 31_337,
    name: 'Hardhat',
    rpcUrls: ['http://127.0.0.1:8545']
  }
};
const allChains = Object.values(chain);
const defaultChains = [chain.mainnet, chain.ropsten, chain.rinkeby, chain.goerli, chain.kovan];
const defaultL2Chains = [chain.optimism, chain.optimismKovan, chain.polygonMainnet, chain.polygonTestnetMumbai, chain.arbitrumOne, chain.arbitrumRinkeby];
const developmentChains = [chain.localhost, chain.hardhat];

const normalizeChainId = chainId => {
  if (typeof chainId === 'string') return Number.parseInt(chainId, chainId.trim().substring(0, 2) === '0x' ? 16 : 10);
  return chainId;
};

class AddChainError extends Error {
  name = 'AddChainError';
  message = 'Error adding chain';
}
class ChainNotConfiguredError extends Error {
  name = 'ChainNotConfigured';
  message = 'Chain not configured';
}
class ConnectorAlreadyConnectedError extends Error {
  name = 'ConnectorAlreadyConnectedError';
  message = 'Connector already connected';
}
class ConnectorNotFoundError extends Error {
  name = 'ConnectorNotFoundError';
  message = 'Connector not found';
}
class SwitchChainError extends Error {
  name = 'SwitchChainError';
  message = 'Error switching chain';
}
class UserRejectedRequestError extends Error {
  name = 'UserRejectedRequestError';
  message = 'User rejected request';
}

class Connector extends EventEmitter {
  /** Unique connector id */

  /** Connector name */

  /** Chains connector supports */

  /** Options to use with connector */

  /** Whether connector is usable */
  constructor({
    chains = defaultChains,
    options
  }) {
    super();
    this.chains = chains;
    this.options = options;
  }

  isChainUnsupported(chainId) {
    return !this.chains.some(x => x.id === chainId);
  }

}

export { AddChainError as A, Connector as C, SwitchChainError as S, UserRejectedRequestError as U, ConnectorNotFoundError as a, allChains as b, ChainNotConfiguredError as c, defaultChains as d, defaultL2Chains as e, chain as f, developmentChains as g, ConnectorAlreadyConnectedError as h, normalizeChainId as n };
